import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'lib-exam-assistant-rail',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './exam-assistant-rail.component.html',
  styleUrls: ['./exam-assistant-rail.component.scss'],
})
export class ExamAssistantRailComponent {
  // --- Inputs ---
  activityLabel = input<string>('');
  remainingSeconds = input.required<number>();
  totalSeconds = input.required<number>();
  showTimer = input<boolean>(true);
  abandonDisabled = input<boolean>(false);
  showAbandon = input<boolean>(true);

  // --- Outputs ---
  expand = output<void>();
  reformulate = output<void>();
  toggleTts = output<void>();
  abandonTest = output<void>();
  openDeviceSettings = output<void>();

  // --- Computed ---
  /** Temps compact : "MM:SS" */
  compactTime = computed(() => {
    const s = Math.max(0, this.remainingSeconds());
    const min = Math.floor(s / 60);
    const sec = s % 60;
    return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  });
}
